import { Component, h, Prop, State, Event, EventEmitter } from '@stencil/core';
import { Homeobj } from '../../model/index';


@Component({
  tag: 'sg-home',
  shadow: false
})
export class Home {

  @Prop() origin: string;
  @Prop() country: string;
  @Prop() type: string;
  @Prop() textsMap: Map<string, any>;

  @State() home: Array<Homeobj>;

  @Event({
    eventName: "selectedPollHome",
    bubbles: false,
  }) selectedPollHome: EventEmitter<string>;

  clickHome(type: string) {
    this.selectedPollHome.emit(type);
  }

  async componentWillLoad() {
    this.home = await fetch(`${process.env.SERVICES_API}/home/${this.country}/${this.origin}/${this.type}`, {
      method: 'GET',
      headers: {
        'Authorization': `Basic ${process.env.SERVICES_TOKEN}` // Adiciona o token ao header Authorization
      }
    }).then(response => response.json());
  }
  render() {
    if (this.home.length > 0) {
      return (
        <div class="u-contain Grid-cell">
          <div class="block">
            <div class="u-textCenter u-padTop">
              <div class="Grid-cell--center u-textCenter u-sm-sizeFull u-textSize2 u-md-textSize4 u-textBold u-textSpacingLoose u-spaceTop2">
                <span class="u-md-padSides1 u-textLoyaltyDarkOrange">{this.textsMap.get(this.home[0].homeTitle)}</span>
              </div>
              <div class="Grid-cell--center u-pad1">
                <img src={this.home[0].homeImage}></img>
                <p class="u-textSize1 u-padLeft2"><strong>{this.textsMap.get(this.home[0].homeDescription)}</strong></p>
              </div>
              <div class="u-textCenter">
                <button class="ButtonMain" value={this.type} onClick={() => this.clickHome(this.type)}>{this.textsMap.get(this.home[0].button)} </button>
              </div>
              <div class="Grid u-spaceTop1 u-padBottom5 u-padSides05">
              </div>
            </div>
          </div>
        </div>
      );
    } else {
      return (<sg-pagenot></sg-pagenot>);
    }
  }
}
